import { RouteObject } from "react-router-dom";
import AboutView from "../pages/AboutView";
import ContactPage from "../pages/ContactPage";
import NotFound from "../pages/NotFound";
import SiteIndex from "../pages/SiteIndex";

export const generalRoutes: RouteObject[] = [
    { path: "/", element: <SiteIndex /> },
    { path: "/about", element: <AboutView /> },
    { path: "/contact", element: <ContactPage /> },
    { path: "*", element: <NotFound /> },
];
